interface UpdateUserProfileData {
	bankAccount?: string;
	phone?: string;
	personalEmail?: string;
	professionalActivity?: string;
}

const updateUserProfile = async (token: string, data: UpdateUserProfileData) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/update-profile`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		});

		const result = await response.json();

		// Check both HTTP status and API wrapper success field
		if (!response.ok || result.success === false) {
			return {
				success: false,
				message: result.message || 'Error updating profile',
				error: result.error || result.data || 'Unknown error'
			};
		}

		return {
			success: true,
			data: result.data || result
		};
	} catch (error) {
		return {
			success: false,
			message: 'Network error',
			error: error
		};
	}
};

export default updateUserProfile;
